import React, { ReactNode, useEffect, useRef } from 'react';
import cn from 'classnames';
import smoothScrollIntoView from 'smooth-scroll-into-view-if-needed';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { Spinner } from '@wix/wix-ui-tpa/cssVars';
import styles from './Widget.scss';

export const CheckoutLoader: React.FC<{ loading: boolean; children: ReactNode }> = ({ loading, children }) => {
  const ref = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (loading && ref.current) {
      smoothScrollIntoView(ref.current, { block: 'center' });
    }
  }, [loading]);

  return (
    <div ref={ref} className={cn(styles.loaderRoot, { [styles.loading]: loading })}>
      <div className={styles.content}>{children}</div>
      {loading && (
        <div data-hook={VIEWER_HOOKS.CHECKOUT_LOADER} className={styles.loaderContainer}>
          <Spinner />
        </div>
      )}
    </div>
  );
};
